import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'

export const _SortBarContainer = styled.div`
  width: 220px;
  position: relative;
  min-width: 220px;

  button {
    height: 44px !important;
  }

  svg {
    top: 50% !important;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;

  }
  .appDropdownFullPage {
    margin-bottom: 0 !important;
  }
`
